import RecentlyAdded from "./RecentlyAdded";

export default RecentlyAdded;